
import React, { useState, useEffect } from "react";
import InvoiceMraketer from "../../components/In/InvoiceMraketer";
import PrimaryButton from "../../components/Button/primaryButton/PrimaryButton";
import "./VisitorPage.css"
import api from "../../api/baseUrl";
import TooltipButton from "../../components/Button/TooltipButton";
import OrangeGradientButton from "../../components/Button/OrangeGradientButton";
import Invoice from "../../components/Invoice/Invoice";
import viewIcon from "../../icons/Property 1=broken (5).svg";
import deleteIcon from "../../icons/trash.svg";
import edidIcon from "../../icons/edit.svg";

import Dropdown from "../../components/Table/DropDown/DropDown";
import SkeletonLoader from "../../components/SkeletonLoader/SkeletonLoader";
import NoData from "../../components/NoData/NoData";
import Pagination from "./Pagination";
import ScrollToTopButton from "../../components/Button/ScrollToTopButton/ScrollToTopButton";
import Snackbar from "../../components/SnackBar/SnackBar";



const Modal = ({ isOpen, onClose, children, fullscreen = false }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className={`modal ${fullscreen ? 'fullscreen' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="modal-close" onClick={onClose}>✕</button>
        {children}
      </div>
    </div>
  );
};

export default function VisitorPage() {
  const [showSellerModal, setShowSellerModal] = useState(false);
  const [activePage, setActivePage] = useState("invoices"); // پیشفرض فاکتورها
  const [expandedInvoiceId, setExpandedInvoiceId] = useState(null);
  const [expandedSellerId, setExpandedSellerId] = useState(null);
    const [phoneError, setPhoneError] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [invoiceDetails, setInvoiceDetails] = useState(null);
  const [invoiceDetailsProduct, setInvoiceDetailsProduct] = useState(null);
  const [paymentError, setPaymentError] = useState("");
  const [newOrder, setNewOrder] = useState({
    amount_toman: "",
    product_id: "",
    marketer_id: "",
    seller_id: "",
    invoice_desc: "",
    paymentTypes: [],
    paymentNotes: { cash: "", cheque: "", other: "" },
    products: []  // ← دیگه آیتم خالی پیشفرض نداره

  });
  const [sellers, setSellers] = useState(); // ← اضافه شد
  const [products, setProducts] = useState(); // ← اضافه شد
  const [orders, setOrders] = useState(); // ← اضافه شد

  const [shouldGroup, setShouldGroup] = useState(false); // پیشفرض با جداکننده

  const [snackbar, setSnackbar] = useState({ message: "", type: "info" });
  const [loading, setLoading] = useState(false);
  const [sellerSearch, setSellerSearch] = useState(""); // برای سرچ فروشندگان
  const [invoiceSearch, setInvoiceSearch] = useState(""); // ← اضافه شد

  const [viewingItem, setViewingItem] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const [editingItem, setEditingItem] = useState(null);


  const [getDataAllInvoice, setGetDataAllInvoice] = useState("");

  const [getAllSeller, setGetAllSeller] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [pagesCount, setPagesCount] = useState(1);
  const [pageProducts, setPageProducts] = useState([]);


  // فاکتورها
  const [currentInvoicePage, setCurrentInvoicePage] = useState(1);
  const [invoicePagesCount, setInvoicePagesCount] = useState(1);

  // فروشگاه‌ها
  const [currentSellerPage, setCurrentSellerPage] = useState(1);
  const [sellerPagesCount, setSellerPagesCount] = useState(1);
  const [countAllData, setCountAllData] = useState(""); // مقداری که با Enter تأیید شده

    const [invoiceCountToday, setInvoiceCountToday] = useState(""); // مقداری که با Enter تأیید شده

      const [invoiceCountWeek, setInvoiceCountWeek] = useState(""); // مقداری که با Enter تأیید شده

  const [invoiceCount, setInvoiceCount] = useState([]);

  const [formData, setFormData] = useState({});


    const [inThisPage, setInThisPage] = useState({});


  const handleEditClick = (seller) => {
    setEditingItem(seller);
    setFormData({ ...seller });
    setShowSellerModal(true);
  };




  const fetchPage = async (page = 1, search = "") => {
    let timer;
    try {
      // لودینگ با تاخیر 200ms
      timer = setTimeout(() => setLoading(true), 200);

      if (activePage === "invoices") {
        // دریافت فاکتورها
        const invoiceData = await handleFetchInvoices(page, invoiceSearch);
        setOrders({
          messages: invoiceData?.messages ?? [],
          pagesCount: invoiceData?.pagesCount ?? 1
        });


        setInThisPage(invoiceData?.messages.length)


        setInvoicePagesCount(invoiceData?.pagesCount ?? 1);
        setCurrentInvoicePage(page); // بروزرسانی صفحه فعلی فاکتورها
      }

      if (activePage === "sellers") {
        // دریافت فروشندگان
        const sellerData = await handleFetchSellers(page, search || sellerSearch,);
        setSellers({
          messages: sellerData?.messages ?? [],
          pagesCount: sellerData?.pagesCount ?? 1
        });
        setSellerPagesCount(sellerData?.pagesCount ?? 1);
        setCurrentSellerPage(page); // بروزرسانی صفحه فعلی فروشندگان
      }
    } catch (err) {
      console.error("❌ Error fetching page:", err);
    } finally {
      clearTimeout(timer);
      setLoading(false);
    }
  };

  const handleOpenModal = async () => {
    setLoading(true);
    try {
      const sellerData = await handleFetchSellers(1, sellerSearch);
      setSellers({
        messages: sellerData?.messages ?? [],
        pagesCount: sellerData?.pagesCount ?? 1
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      setShowModal(true); // بعد از لود داده‌ها مودال باز می‌شود
    }
  };

  // وقتی مودال باز شد، داده‌های فروشندگان را لود کن
  useEffect(() => {
    if (showModal && (!sellers || !sellers.messages?.length)) {
      fetchPage(1, ""); // fetchPage شما خودش sellers را آپدیت می‌کنه
    }
  }, [showModal]);


  useEffect(() => {
    fetchPage(1); // وقتی سرچ تغییر کرد، همیشه صفحه اول رو میگیریم
  }, [sellerSearch, activePage]);



  const handleFetchSellers = async (page = 1, search = "") => {
    try {
      const response = await api.get("/get-sellers", {
        // params: { page, s: search ,limit:1000}, // 👈 اضافه شد: s برای جستجو

          params: {
          page,
          limit: 5000 , // حالا limit داخل params است
      s:search
        }
      });


      const data = response.data;

      return {
        messages: data?.messages ?? data ?? [],
        pagesCount: data?.pagesCount ?? 1,
      };
    } catch (err) {
      console.error("❌ Fetch Sellers Error:", err.response?.data || err.message);
      return { messages: [], pagesCount: 1 };
    }
  };


  

  const handleSubmit = async (e) => {
    e.preventDefault();
    let url = "/crud-sellers";

    const isEditing = Boolean(editingItem);

    let body = isEditing
      ? {
        action: "update",
        id: editingItem.id,
        name: formData.name || "",
        surname: formData.surname || "",
        phone_number: formData.phone || "",
        landline_number: formData.land_line || "",
        address: formData.address || "",
        city: formData.city || "",
        province: formData.province || "",
        shop_name: formData.shop_name || "",
      }
      : {
        action: "add",
        name: formData.name || "",
        surname: formData.surname || "",
        phone_number: formData.phone || "",
        landline_number: formData.land_line || "",
        address: formData.address || "",
        city: formData.city || "",
        province: formData.province || "",
        shop_name: formData.shop_name || "",
      };

    try {
      const result = await api.post(url, body);

      if (result.data.accepted === true) {
        setSnackbar({
          title: "موفقیت",
          description: isEditing
            ? "فروشگاه با موفقیت آپدیت شد!"
            : `فروشگاه ${formData.shop_name || "جدید"} با موفقیت اضافه شد!`,
          type: "success",
        });

        await fetchPage(currentPage); // ← رفرش کامل جدول
      } else {
        setSnackbar({
          title: "خطا",
          description: isEditing
            ? "عملیات ویرایش ناموفق بود!"
            : "عملیات اضافه‌کردن ناموفق بود!",
          type: "error",
        });
      }

      setShowSellerModal(false);
      setFormData({});
    } catch (error) {
      console.error("خطا در ارسال داده:", error);
      setSnackbar({
        title: "خطا",
        description: "مشکلی در ارتباط با سرور پیش آمد.",
        type: "error",
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));



  };


  const handleFetchProducts = async (page = 1) => {
    try {
      const response = await api.get("/get-products", {
        params: {
          page,
          limit: 5000  // حالا limit داخل params است
        }
      });


      // این برای استیت لوکال در parent
      setProducts(response.data.messages);

      // این برای TableProducts
      return {
        messages: response.data.messages,
        pagesCount: response.data.pagesCount,
      };
    } catch (err) {
      console.error("Fetch Products Error:", err.response?.data || err.message);
      return { messages: [], pagesCount: 1 }; // جلوگیری از undefined
    }
  };


  {/* مجموع کل محصولات */ }
  const totalProductsAmount = newOrder.products
    .filter(p => p.product_id)
    .reduce((total, p) => total + (p.product_quantity * Number(p.selling_price)), 0);

  // جمع پرداخت شده
  const totalPaidAmount = Object.values(newOrder.paymentAmounts || {}).reduce(
    (sum, val) => sum + Number(val || 0),
    0
  );

  // مانده قابل پرداخت
  const remainingAmount = totalProductsAmount - totalPaidAmount;


  const handleFetchInvoices = async (page = 1) => {
    try {
      const response = await api.get("/get-invoices", {
        params: { page, s: invoiceSearch },
      });
      const data = response.data;


      setCountAllData(response.data.count)
      setInvoiceCount(response.data.invoiceCount)

      setInvoiceCountToday(response.data.invoiceCountToday)
      setInvoiceCountWeek(response.data.invoiceCountWeek)


      return {
        messages: data?.messages ?? [],
        pagesCount: data?.pagesCount ?? 1,
      };
    } catch (err) {
      console.error("❌ Fetch Invoices Error:", err);
      return { messages: [], pagesCount: 1 };
    }
  };



  function getPersianDateTime() {
    const date = new Date();
    const [year, month, day] = new Intl.DateTimeFormat('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' })
      .format(date)
      .split('/');

    const [hour, minute, second] = [
      date.getHours().toString().padStart(2, '0'),
      date.getMinutes().toString().padStart(2, '0'),
      date.getSeconds().toString().padStart(2, '0'),
    ];

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  }

  





  const handleAddOrder = async (e) => {
    e.preventDefault();

    // -----------------------------
    // 🎯 ساخت داده‌های پرداخت
    // -----------------------------
    const payment_cash = newOrder.paymentTypes.includes("cash") ? "1" : "0";
    const payment_cheque = newOrder.paymentTypes.includes("cheque") ? "1" : "0";
    const payment_other = newOrder.paymentTypes.includes("other") ? "1" : "0";

    const payment_cash_desc = newOrder.paymentNotes.cash || "پرداخت نقدی";
    const payment_cheque_desc = newOrder.paymentNotes.cheque || "پرداخت چکی";
    const payment_other_desc = newOrder.paymentNotes.other || "نسیه پرداخت‌ها";

    const payment_cash_price = newOrder.paymentAmounts.cash || "0";
    const payment_cheque_price = newOrder.paymentAmounts.cheque || "0";
    const payment_other_price = newOrder.paymentAmounts.other || "0";

    // -----------------------------
    // 🧾 لیست محصولات انتخاب‌شده
    // -----------------------------
    const products = newOrder.products
      .filter(p => p.product_id)
      .map(p => ({
        product_id: p.product_id.toString(),
        product_quantity: p.product_quantity,
        selling_price: p.selling_price.toString(),
      }));

    // -----------------------------
    // 📦 داده نهایی برای ارسال
    // -----------------------------


    // تاریخ میلادی امروز
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const hour = String(today.getHours()).padStart(2, '0');
    const minute = String(today.getMinutes()).padStart(2, '0');
    const second = String(today.getSeconds()).padStart(2, '0');

    const date_created = `${year}-${month}-${day} ${hour}:${minute}:${second}`;


    const body = {
      action: "add",
      date_created: date_created,
      seller_id: newOrder.seller_id,
      marketer_id: newOrder.marketer_id,
      payment_cash,
      payment_cash_desc,
      payment_cash_price,
      payment_cheque,
      payment_cheque_desc,
      payment_cheque_price,
      payment_other,
      payment_other_desc,
      payment_other_price,
      invoice_desc: newOrder.invoice_desc,
      products,
    };

    // -----------------------------
    // 🚀 ارسال به سرور
    // -----------------------------
    try {
      const result = await api.post("/crud-invoices", body);

      if (result.data.accepted === true) {
        setShowModal(false); // بستن مودال فقط در صورت موفقیت

        setSnackbar({
          title: "فاکتور ثبت شد",
          description: "فاکتور شما با موفقیت ثبت گردید.",
          type: "success",
        });

        await fetchPage(currentPage); // رفرش جدول

        // ریست فرم سفارش
        setNewOrder({
          marketer_id: "",
          seller_id: "",
          invoice_desc: "",
          paymentTypes: [],
          paymentNotes: { cash: "", cheque: "", other: "" },
          paymentAmounts: { cash: "", cheque: "", other: "" },
          paymentAmountsDisplay: { cash: "", cheque: "", other: "" },
          products: [],
        });
      } else {
        setSnackbar({
          title: "خطا",
          description: result.data.message || "ارسال فاکتور موفق نبود!",
          type: "error",
        });
      }
    } catch (error) {
      console.error("خطا در ارسال فاکتور:", error);
      setSnackbar({
        title: "خطا در ارتباط با سرور",
        description: "لطفاً اتصال اینترنت یا سرور را بررسی کنید.",
        type: "error",
      });
    }
  };

  // const handleSeeDetails = async (id) => {
  //   try {
  //     const result = await api.post("/view-invoice", { invoice_id: id });
  //     if (result.data.accepted && result.data.message) {
  //       setInvoiceDetails(result.data.message.invoice_data);
  //       // console.log(result.data.message.invoice_products[0]);

  //       setShowInvoiceModal(true);
  //       setInvoiceDetailsProduct(result.data.message.invoice_products)
  //     } else {
  //       alert("اطلاعات فاکتور یافت نشد");
  //     }
  //   } catch (error) {
  //     console.error("خطا در دریافت فاکتور:", error);
  //     alert("خطا در دریافت اطلاعات فاکتور");
  //   }
  // };

  const handleSeeDetails = async (id) => {
    let timer;

    try {
      // ⏱ نمایش لودینگ فقط اگر درخواست بیش از 200ms طول بکشه
      timer = setTimeout(() => setLoading(true), 200);

      const result = await api.post("/view-invoice", { invoice_id: id });

      // ✅ وقتی نتیجه رسید، حتی اگر سریع بود، تایمر رو لغو می‌کنیم
      clearTimeout(timer);
      setLoading(false);

      if (result.data.accepted === true) {
        const invoiceData = result.data.message.invoice_data;
        const invoiceProducts = result.data.message.invoice_products;

        setInvoiceDetails(invoiceData);
        setInvoiceDetailsProduct(invoiceProducts);
        setShowInvoiceModal(true);


      } else {
        setSnackbar({
          title: "خطا",
          description: "اطلاعات فاکتور یافت نشد!",
          type: "error",
        });
      }
    } catch (error) {
      console.error("خطا در دریافت فاکتور:", error);
      clearTimeout(timer);
      setLoading(false);
      setSnackbar({
        title: "خطا در ارتباط با سرور",
        description: "در دریافت اطلاعات فاکتور مشکلی پیش آمد.",
        type: "error",
      });
    } finally {
      clearTimeout(timer);
      setLoading(false);
    }
  };


  const handleSeeDetailsُSeller = async (id) => {
    let timer;

    try {
      // ⏱ نمایش لودینگ فقط اگر درخواست طول بکشه
      timer = setTimeout(() => setLoading(true), 200);

      const result = await api.post("/crud-sellers", { action: "get", id });

      clearTimeout(timer);
      setLoading(false);

      if (result.data?.accepted && result.data?.message?.length > 0) {
        const sellerData = result.data.message[0];

        setViewingItem(sellerData);
        setEditingItem(null);
        setModalOpen(true);
      } else {
        setSnackbar({
          title: "خطا",
          description: "اطلاعات فروشنده یافت نشد!",
          type: "error",
        });
      }
    } catch (error) {
      clearTimeout(timer);
      setLoading(false);

      setSnackbar({
        title: "خطا در ارتباط با سرور",
        description: "در دریافت اطلاعات فروشنده مشکلی پیش آمد.",
        type: "error",
      });
    } finally {
      clearTimeout(timer);
      setLoading(false);
    }
  };



  useEffect(() => {
    handleFetchProducts();
    handleFetchInvoices();
    handleFetchSellers()
  }, []);

  // const handleDeleteItem = async ({ id, type }) => {
  //   try {
  //     let url = "";
  //     let body = {};

  //     if (type === "invoice") {
  //       url = "/crud-invoices";
  //       body = { action: "delete", invoice_id: id };
  //     } else if (type === "seller") {
  //       url = "/crud-sellers";
  //       body = { action: "delete", id };
  //     } else {
  //       console.warn("نوع نامعتبر برای حذف");
  //       return;
  //     }

  //     const result = await api.post(url, body);

  //     if (result.data.accepted === true) {

  //         setSnackbar({
  //         title: "موفقیت",
  //         description: `فاکتور  با موفقیت اضافه شد!`,
  //         type: "success"
  //       });


  //       await fetchPage(currentPage); // ← این باعث رفرش کامل جدول میشه

  //     } else {
  //       setSnackbar({ message: "حذف ناموفق بود", type: "error" });
  //     }
  //   } catch (error) {
  //     console.error("خطا در حذف:", error);
  //     setSnackbar({ message: "خطا در حذف", type: "error" });
  //   } finally {
  //     setDeleteModalOpen(false);
  //     setDeleteItemId(null);
  //   }
  // };
  const handleDeleteItem = async ({ id, type }) => {
    try {
      let url = "";
      let body = {};
      let itemLabel = "";

      if (type === "invoice") {
        url = "/crud-invoices";
        body = { action: "delete", invoice_id: id };
        itemLabel = "فاکتور";
      } else if (type === "seller") {
        url = "/crud-sellers";
        body = { action: "delete", id };
        itemLabel = "فروشگاه";
      } else {
        console.warn("نوع نامعتبر برای حذف");
        return;
      }

      const result = await api.post(url, body);

      if (result.data.accepted === true) {
        setSnackbar({
          title: "موفقیت",
          description: `${itemLabel} با موفقیت حذف شد!`,
          type: "success"
        });

        await fetchPage(currentPage); // ← رفرش کامل جدول
      } else {
        setSnackbar({
          title: "خطا",
          description: "عملیات حذف ناموفق بود!",
          type: "error"
        });
      }
    } catch (error) {
      console.error("خطا در حذف:", error);
      setSnackbar({
        title: "خطا",
        description: "در فرآیند حذف خطایی رخ داد!",
        type: "error"
      });
    } finally {
      setDeleteModalOpen(false);
      setDeleteItemId(null);
    }
  };




  return (
    <>





      <div className="visitors-app">
        {/* لینک‌ها / تب‌ها */}
        <div className="tabs">
          <button
            className={`invoice-tab-btn ${activePage === "invoices" ? "active" : ""}`}
            onClick={() => setActivePage("invoices")}
          >
            فاکتورها
          </button>
          <button
            className={activePage === "sellers" ? "active" : ""}
            onClick={() => setActivePage("sellers")}
          >
            فروشگاه ها          </button>
        </div>

        {/* محتوای صفحه بر اساس تب فعال */}
        {activePage === "invoices" && (
          <>


            <div class="card-header">
              <h2 className="card-header-title">فاکتور ها</h2>
              <div class="buttons">
                <OrangeGradientButton onClick={handleOpenModal}>
                  افزودن فاکتور
                </OrangeGradientButton>  </div>
            </div>

            {/* ---- فیلد جستجو فاکتورها ---- */}
            <div style={{ margin: '1rem 0' }}>
              <input
                type="text"
                placeholder="جستجوی فاکتور..."
                value={invoiceSearch}
                onChange={(e) => {
                  const value = e.target.value;
                  setInvoiceSearch(value);
                  setCurrentPage(1);
                  fetchPage(1, value); // هر بار که متن تغییر کرد، fetchPage با مقدار جستجو فراخوانی می‌شود
                }}
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  fontSize: '16px',
                  borderRadius: '6px',
                  border: '1px solid #ccc'
                }}
              />
            </div>





            <div className="table-container-visitor">


                          <div class="stats-container">
        
        <div class="cards-grid">
            <div class="stat-card card-all-invoices">
                <div class="card-header">
                    <div class="card-data">
                        <p class="card-label">همه فاکتورها</p>
                        <p class="card-value"> {Number(invoiceCount || 0).toLocaleString('fa-IR')}</p>
                        
                    
                    </div>
                    <div class="icon-container">
                        <i class="fas fa-file-invoice card-icon"></i>
                    </div>
                </div>
            </div>

            <div class="stat-card card-total-items">
                <div class="card-header">
                    <div class="card-data">
                        <p class="card-label">تعداد آیتم ها</p>
                        <p class="card-value">  {Number(countAllData || 0).toLocaleString('fa-IR')}</p>
                      
                    </div>
                    <div class="icon-container">
                        <i class="fas fa-cube card-icon"></i>
                    </div>
                </div>
            </div>

            <div class="stat-card card-today-invoices">
                <div class="card-header">
                    <div class="card-data">
                        <p class="card-label">فاکتورهای امروز</p>
                        <p class="card-value">{Number(invoiceCountToday || 0).toLocaleString('fa-IR')}
</p>
                    
                    </div>
                    <div class="icon-container">
                        <i class="fas fa-calendar-day card-icon"></i>
                    </div>
                </div>
            </div>

            <div class="stat-card card-week-invoices">
                <div class="card-header">
                    <div class="card-data">
                        <p class="card-label">فاکتورهای هفته</p>
                        <p class="card-value">{Number(invoiceCountWeek || 0).toLocaleString('fa-IR')}</p>
                
                    </div>
                    <div class="icon-container">
                        <i class="fas fa-calendar-week card-icon"></i>
                    </div>
                </div>
            </div>
        </div>

 
    </div>
        


              {loading ? (
                <SkeletonLoader rows={20} />
              ) : orders?.messages?.length > 0 ? (
                <div className="mobile-cards">
                  {orders.messages.map((order) => {
                    const invoiceNumberStr = String(order.invoice_id);
                    const isExpanded = expandedInvoiceId === invoiceNumberStr;

                    return (
                      <div
                        key={order.invoice_id}
                        className={`order-card ${isExpanded ? "expanded" : ""}`}
                        onClick={() => setExpandedInvoiceId(isExpanded ? null : invoiceNumberStr)}
                      >
                        <div className="mobile-card-header">
                          <div className="header-left">
                            <span> {order.invoice_number}#</span>
                          </div>

                          <div className="header-right">
                            <span className="amount2">
                              مبلغ: {Number(order.selling_price).toLocaleString('fa-IR')} تومان
                            </span>

                            <TooltipButton
                              icon={viewIcon}
                              alt="فاکتور"
                              tooltipText="فاکتور"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleSeeDetails(order.invoice_id);
                              }}
                            />
                            <TooltipButton
                              icon={deleteIcon}
                              alt="حذف"
                              tooltipText="حذف"
                              onClick={(e) => {
                                e.stopPropagation();
                                setDeleteItemId(order.invoice_id);
                                setDeleteModalOpen(true);
                              }}
                              className="delete-btn"
                            />
                          </div>
                        </div>

                        {isExpanded && (
                          <div className="card-body">
                            <div><strong>شناسه فاکتور:</strong> {order.invoice_id}</div>
                            <div><strong>شماره فاکتور:</strong> {order.invoice_number}</div>
                            <div><strong>نام محصول:</strong> {order.product_name}</div>
                            <div><strong>تعداد فاکتور:</strong> {order.product_quantity}</div>
                            <div><strong>مبلغ فروش (تومان):</strong> {Number(order.selling_price).toLocaleString('fa-IR')}</div>
                          </div>
                        )}
                        
                      </div>
                      
                    );
                    

                  })}


                  {activePage === "invoices" && (
                    <Pagination
                      currentPage={currentInvoicePage}
                      pagesCount={invoicePagesCount}

                      inThisPage={inThisPage}
                      onPageChange={(page) => fetchPage(page)}
                    />
                    
                  )}
                  





                </div>
              ) : (
                <div className="no-data-message">
                  <NoData message="هیچ فاکتوری یافت نشد" />
                </div>
              )}
            </div>

          </>
        )}

        {activePage === "sellers" && (
          <>



            <div class="card-header">
              <h2 className="card-header-title">فروشگاه ها</h2>
              <div class="buttons">
                <OrangeGradientButton onClick={() => {
                  setEditingItem(null); // برای افزودن جدید
                  setFormData({});      // ریست فرم
                  setShowSellerModal(true);
                }}>
                  افزودن فروشگاه
                </OrangeGradientButton>
              </div>
            </div>


            <div style={{ margin: '1rem 0' }}>
              <input
                type="text"
                placeholder="جستجوی فروشگاه..."
                value={sellerSearch}
                onChange={(e) => setSellerSearch(e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  fontSize: '16px',
                  borderRadius: '6px',
                  border: '1px solid #ccc'
                }}
              />
            </div>








            <div className="table-container-visitor">

              {loading ? (
                <SkeletonLoader rows={20} />
              ) : sellers?.messages?.length > 0 ? (
                <div className="mobile-cards">
                  {sellers.messages.map((seller) => {
                    const sellerIdStr = String(seller.id);
                    const isExpanded = expandedSellerId === sellerIdStr;

                    return (
                      <div
                        key={seller.id}
                        className={`order-card ${isExpanded ? "expanded" : ""}`}
                        onClick={() => setExpandedSellerId(isExpanded ? null : sellerIdStr)}
                      >
                        <div className="mobile-card-header">
                          <div className="header-left">
                            <span>{seller.name} {seller.surname} - {seller.shop_name}</span>
                          </div>
                          <div className="header-right">
                            <TooltipButton
                              icon={viewIcon}
                              alt="جزئیات"
                              tooltipText="جزئیات"
                              onClick={() => handleSeeDetailsُSeller(seller.id)}
                              className="margin-btn"
                            />
                            <TooltipButton
                              icon={edidIcon}
                              alt="ویرایش"
                              tooltipText="ویرایش"
                              onClick={() => handleEditClick(seller)}
                            />
                            <TooltipButton
                              icon={deleteIcon}
                              alt="حذف"
                              tooltipText="حذف"
                              onClick={(e) => {
                                e.stopPropagation();
                                setDeleteItemId(seller.id);
                                setDeleteModalOpen(true);
                              }}
                              className="delete-btn"
                            />
                          </div>
                        </div>

                        {isExpanded && (
                          <div className="card-body">
                            <div><strong>نام:</strong> {seller.name}</div>
                            <div><strong>نام خانوادگی:</strong> {seller.surname}</div>
                            <div><strong>شماره تماس:</strong> {seller.phone}</div>
                            <div><strong>تلفن ثابت:</strong> {seller.land_line}</div>
                            <div><strong>نام فروشگاه:</strong> {seller.shop_name}</div>
                            <div><strong>استان:</strong> {seller.province}</div>
                            <div><strong>شهر:</strong> {seller.city}</div>
                          </div>
                        )}
                      </div>
                    );
                  })}

                  {activePage === "sellers" && (
                    <Pagination
                      currentPage={currentSellerPage}
                      pagesCount={sellerPagesCount}
                      onPageChange={(page) => fetchPage(page)}
                      
                    />
                  )}


                </div>
              ) : (
                <div className="no-data-message">
                  <NoData message="هیچ فروشگاهی یافت نشد" />
                </div>
              )}
            </div>








          </>
        )}



      </div>

      <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
        <h3 className="modal-title">افزودن فاکتور جدید</h3>
        <form className="modal-form" onSubmit={handleAddOrder}>

          <div className="wrapper-column">
            {/* <Dropdown
              type="single"
              value={newOrder.marketer_id}
              onChange={(id) => setNewOrder({ ...newOrder, marketer_id: id })}
              items={visitors}
              placeholder="انتخاب ویزیتور"
              itemType="marketer"

            /> */}


            {/* فروشنده */}
            <Dropdown
              type="single"
              value={newOrder.seller_id}
              onChange={(id) => setNewOrder({ ...newOrder, seller_id: id })}
              items={sellers?.messages || []}   // ✅ فقط messages
              placeholder="انتخاب فروشگاه"
              itemType="seller"
            />


          </div>


          <h3 className="modal-title">انتخاب محصولات</h3>

          {/* انتخاب محصول */}
          <div className="form__input-group">

            <Dropdown
              type="single"
              value={newOrder.product_id}
              onChange={(id) => {
                const selectedProduct = products.find((p) => p.id.toString() === id);
                setNewOrder((prev) => ({
                  ...prev,
                  product_id: id,
                  amount_toman: selectedProduct?.price || "",
                  amount_toman_display: selectedProduct
                    ? Number(selectedProduct.price).toLocaleString("fa-IR")
                    : "",
                }));
              }}
              items={products?.map(p => ({
                id: p.id?.toString(),
                name: `${p.name} ${p.category} ${p.brand} - ${Number(p.price).toLocaleString("fa-IR")} تومان`
              })) || []}

              placeholder="انتخاب محصول"
            />


          </div>

          {/* تعداد محصول */}
          <div className="form__input-group">
            <input
              type="number"
              name="product_quantity"
              placeholder=" "
              value={newOrder.product_quantity || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || Number(value) >= 0) {
                  setNewOrder({ ...newOrder, product_quantity: value });
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "-" || e.key === "e") {
                  e.preventDefault(); // نذاره منفی یا e وارد شه
                }
              }}
              className="form__input no-negative"
            />

            <label className="form__input-label">تعداد محصول (قوطی)</label>
          </div>

          {/* مبلغ فروش */}
          <div className="form__input-group">
            <input
              type="text"
              name="amount_toman"
              placeholder=" "
              value={newOrder.amount_toman_display || ""}
              onChange={(e) => {
                const numericValue = e.target.value.replace(/\D/g, "");
                setNewOrder((prev) => ({
                  ...prev,
                  amount_toman: numericValue,
                  amount_toman_display: numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                }));
              }}
              className="form__input"
            />
            <label className="form__input-label">مبلغ فروش (تومان)</label>
          </div>

          {/* دکمه افزودن محصول */}

          <PrimaryButton title={"+ افزودن محصول"} onClick={() => {
            if (newOrder.product_id && newOrder.product_quantity && newOrder.amount_toman) {
              setNewOrder((prev) => ({
                ...prev,
                products: [
                  ...(prev.products || []),
                  {
                    product_id: prev.product_id,
                    product_quantity: parseInt(prev.product_quantity, 10),
                    selling_price: prev.amount_toman.toString(),
                  },
                ],
                // product_id: "",
                // product_quantity: "",
                // amount_toman: "",
              }));
            } else {
              alert("لطفا محصول، تعداد و مبلغ را وارد کنید");
            }
          }} />

          {/* محصولات انتخاب‌شده */}
          {newOrder.products && newOrder.products.length > 0 && (
            <div

            >
              <h3
                className="modal-title"
                style={{
                  marginBottom: '1rem',
                }}
              >
                محصولات انتخاب شده
              </h3>

              <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                {newOrder.products
                  .filter(p => p.product_id)
                  .map((p, i) => {
                    const prodName = products.find(pr => pr.id.toString() === p.product_id)?.name;

                    const prodBrand = products.find(pr => pr.id.toString() === p.product_id)?.brand;

                    const prodCategory = products.find(pr => pr.id.toString() === p.product_id)?.category;


                    if (!prodName) return null;
                    return (
                      <li
                        key={i}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          backgroundColor: '#fff',
                          padding: '0.75rem 1rem',
                          marginBottom: '0.75rem',
                          borderRadius: '8px',
                          border: '1px solid #e5e5e5',
                          transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
                        }}
                      >
                        {/* <span style={{ fontSize: '16px', color: '#555', lineHeight: 1.6 }}>
                          {prodName} {prodCategory} {prodBrand}  — تعداد: {new Intl.NumberFormat('fa-IR').format(p.product_quantity)} — قیمت:{' '}
                          {Number(p.selling_price).toLocaleString('fa-IR')}
                        </span> */}
                        <span style={{ fontSize: '16px', color: '#555', lineHeight: 1.6 }}>
                          {prodName} {prodCategory} {prodBrand} — تعداد: {new Intl.NumberFormat('fa-IR').format(p.product_quantity)} — قیمت واحد: {Number(p.selling_price).toLocaleString('fa-IR')} — قیمت کل: {(p.product_quantity * Number(p.selling_price)).toLocaleString('fa-IR')}
                        </span>

                        <TooltipButton
                          icon={deleteIcon}
                          alt="حذف"
                          tooltipText="حذف"
                          onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                            setNewOrder(prev => ({
                              ...prev,
                              products: prev.products.filter((_, idx) => idx !== i),
                            }));
                          }}
                          className="delete-btn margin-btn" />
                      </li>
                    );
                  })}
              </ul>
            </div>
          )}

          {/* جمع کل محصولات */}
          <div style={{ marginTop: '1rem', fontWeight: 'bold', fontSize: '16px', color: '#333' }}>
            مجموع کل:{" "}
            {newOrder.products
              .filter(p => p.product_id)
              .reduce((total, p) => total + (p.product_quantity * Number(p.selling_price)), 0)
              .toLocaleString('fa-IR')} تومان
          </div>
          {/* بخش تسویه */}
          <div className="payment-section">
            <h3 className="modal-title">نحوه تسویه :  </h3>
            <div className="remaining-amount" style={{ marginTop: '1rem', fontWeight: 'bold', color: '#333' }}>
              مانده قابل پرداخت: {remainingAmount.toLocaleString('fa-IR')} تومان
            </div>

            {["cash", "cheque", "other"].map((type) => {
              const labels = { cash: "نقدی", cheque: "چکی", other: "نسیه" };
              return (
                <div key={type} className="payment-type">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={newOrder.paymentTypes.includes(type)}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setNewOrder((prev) => ({
                          ...prev,
                          paymentTypes: checked
                            ? [...prev.paymentTypes, type]
                            : prev.paymentTypes.filter((p) => p !== type),
                          paymentNotes: { ...prev.paymentNotes, [type]: "" },
                          paymentAmounts: { ...prev.paymentAmounts, [type]: "" },
                          paymentAmountsDisplay: { ...prev.paymentAmountsDisplay, [type]: "" },
                        }));
                      }}
                    />
                    <span>{labels[type]}</span>
                  </label>

                  {newOrder.paymentTypes.includes(type) && (
                    <div className="payment-details">
                      <input
                        type="text"
                        className={`payment-${type}-price form__input`}
                        placeholder="مبلغ"
                        value={newOrder.paymentAmountsDisplay?.[type] || ""}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(/\D/g, "");
                          const newPaymentAmounts = { ...newOrder.paymentAmounts, [type]: numericValue };
                          const totalPaid = Object.values(newPaymentAmounts).reduce((sum, val) => sum + Number(val || 0), 0);

                          if (totalPaid > totalProductsAmount) {
                            setPaymentError("مجموع پرداخت‌ها نمی‌تواند بیشتر از کل مبلغ باشد!");
                          } else {
                            setPaymentError("");
                          }

                          setNewOrder((prev) => ({
                            ...prev,
                            paymentAmounts: newPaymentAmounts,
                            paymentAmountsDisplay: {
                              ...prev.paymentAmountsDisplay,
                              [type]: numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                            },
                          }));
                        }}

                      />

                      {paymentError && (
                        <div style={{ color: "red", marginTop: "0.5rem", fontWeight: "bold" }}>
                          {paymentError}
                        </div>
                      )}

                      <textarea
                        placeholder={`توضیح پرداخت ${labels[type]}`}
                        value={newOrder.paymentNotes[type]}
                        onChange={(e) =>
                          setNewOrder((prev) => ({
                            ...prev,
                            paymentNotes: { ...prev.paymentNotes, [type]: e.target.value },
                          }))
                        }
                        rows={3}
                      />
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* توضیح فاکتور */}
          <div className="form__input-group invoice-explanation">
            <input
              type="text"
              name="invoice_desc"
              placeholder=" "
              value={newOrder.invoice_desc}
              onChange={(e) =>
                setNewOrder({ ...newOrder, invoice_desc: e.target.value })

              }
              className="form__input"
            />
            <label className="form__input-label">توضیح فاکتور</label>
          </div>

          <PrimaryButton type="submit" title="ذخیره فاکتور" loading={loading} disabled={
            !!paymentError ||
            remainingAmount !== 0 ||
            !(newOrder.products?.length > 0)
          }
          />

        </form>

      </Modal>

    <Modal isOpen={showSellerModal} onClose={() => setShowSellerModal(false)}>
  <h2 className="modal-title">
    {editingItem ? "ویرایش فروشگاه" : "افزودن فروشگاه جدید"}
  </h2>

  <form className="modal-form" onSubmit={handleSubmit}>
    {/* نام */}
    <div className="form__input-group">
      <input
        type="text"
        name="name"
        placeholder=" "
        value={formData.name || ""}
        onChange={handleChange}
        required
        maxLength={45}
        className="form__input"
      />
      <label className="form__input-label">نام</label>
    </div>

    {/* نام خانوادگی */}
    <div className="form__input-group">
      <input
        type="text"
        name="surname"
        placeholder=" "
        value={formData.surname || ""}
        onChange={handleChange}
        required
        maxLength={45}
        className="form__input"
      />
      <label className="form__input-label">نام خانوادگی</label>
    </div>

    {/* شماره تماس با پیش‌شماره 09 */}
    <div className="form__input-group phone-input-group">
      <div className="phone-input-wrapper">
        <span className="phone-prefix">09</span>
        <input
          type="tel"
          name="phone"
          placeholder=" "
          value={formData.phone?.slice(2) || ""}
          onChange={(e) => {
            let val = e.target.value.replace(/\D/g, "");
            if (val.length > 9) val = val.slice(0, 9);
            const fullNumber = "09" + val;
            setFormData((prev) => ({ ...prev, phone: fullNumber }));
          }}
          onBlur={() => {
            const digits = formData.phone?.replace(/\D/g, "") || "";
            if (digits.length < 11) {
              setPhoneError("شماره تماس باید ۱۱ رقم باشد (مثل 09123456789)");
            } else {
              setPhoneError("");
            }
          }}
          maxLength={9}
          className={`form__input phone-input ${phoneError ? "has-error" : ""}`}
          inputMode="numeric"
          required
        />
        <label className="form__input-label phone-label">شماره تماس</label>
      </div>
      {phoneError && <span className="phone-error">{phoneError}</span>}
    </div>

    {/* تلفن ثابت بدون پیش‌شماره */}
    <div className="form__input-group">
      <input
        type="tel"
        name="land_line"
        placeholder=" "
        value={formData.land_line || ""}
        onChange={(e) => {
          let val = e.target.value.replace(/\D/g, "");
          if (val.length > 11) val = val.slice(0, 11);
          setFormData((prev) => ({ ...prev, land_line: val }));
        }}
        maxLength={11}
        className="form__input"
        inputMode="numeric"
      />
      <label className="form__input-label">تلفن ثابت</label>
    </div>

    {/* نام فروشگاه */}
    <div className="form__input-group">
      <input
        type="text"
        name="shop_name"
        placeholder=" "
        value={formData.shop_name || ""}
        onChange={handleChange}
        required
        maxLength={45}
        className="form__input"
      />
      <label className="form__input-label">نام فروشگاه</label>
    </div>

    {/* استان و شهر */}
    <div className="form__input-group">
      <Dropdown
        type="provinceCity"
        value={{ province: formData.province, city: formData.city }}
        onChange={(val) => {
          const { province, city } = val;
          setFormData((prev) => ({
            ...prev,
            province,
            city,
            address: city && province ? `${province},${city},` : prev.address,
          }));
        }}
      />
    </div>

    {/* آدرس */}
    <div className="form__input-group">
      <input
        type="text"
        name="address"
        placeholder=" "
        value={formData.address || ""}
        onChange={handleChange}
        required
        maxLength={300}
        className="form__input"
      />
      <label className="form__input-label">آدرس</label>
    </div>

    <PrimaryButton
      type="submit"
      title={editingItem ? "ویرایش فروشگاه" : "افزودن فروشگاه"}
    />
  </form>
</Modal>


      <Modal isOpen={isDeleteModalOpen} onClose={() => setDeleteModalOpen(false)}>
        <h3 className="delete-modal-title">آیا مطمئن هستید که می‌خواهید این مورد را حذف کنید؟</h3>
        <div className="modal-buttons">
          <button className="btn cancel-btn" onClick={() => setDeleteModalOpen(false)}>انصراف</button>
          <button
            className="btn confirm-btn"
            onClick={() => {
              handleDeleteItem({
                id: deleteItemId,
                type: activePage === "invoices" ? "invoice" : "seller"
              });
            }}
          >
            تایید
          </button>

        </div>
      </Modal>


      {/* مودال نمایش اطلاعات فاکتور */}
      {showInvoiceModal && invoiceDetails && invoiceDetailsProduct && (
        <Modal
          isOpen={showInvoiceModal}
          onClose={() => setShowInvoiceModal(false)}
          fullscreen={true}
        >
          <Invoice
            invoiceDetails={invoiceDetails}
            invoiceDetailsProduct={invoiceDetailsProduct}
          />
        </Modal>




      )}

      {/*  مودال جزئیات سلر*/}
      {modalOpen && viewingItem && (
        <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
          <div className="modal-info-content">
            <h3 className="modal-title">جزئیات فروشگاه</h3>
            <div className="modal-info">
              <div className="info-row">
                <span className="info-label">نام:</span>
                <span className="info-value">{viewingItem.name}</span>
              </div>
              <div className="info-row">
                <span className="info-label">نام خانوادگی:</span>
                <span className="info-value">{viewingItem.surname}</span>
              </div>
              <div className="info-row">
                <span className="info-label">شماره تماس:</span>
                <span className="info-value">{viewingItem.phone}</span>
              </div>
              <div className="info-row">
                <span className="info-label">تلفن ثابت:</span>
                <span className="info-value">{viewingItem.landline_number}</span>
              </div>
              <div className="info-row">
                <span className="info-label">نام فروشگاه:</span>
                <span className="info-value">{viewingItem.shop_name}</span>
              </div>
              <div className="info-row">
                <span className="info-label">استان:</span>
                <span className="info-value">{viewingItem.province}</span>
              </div>
              <div className="info-row">
                <span className="info-label">شهر:</span>
                <span className="info-value">{viewingItem.city}</span>
              </div>
              <div className="info-row">
                <span className="info-label">آدرس:</span>
                <span className="info-value">{viewingItem.address}</span>
              </div>
              {/* <div className="info-row">
                <span className="info-label">مارکتر:</span>
                <span className="info-value">{viewingItem.marketer}</span>
            </div> */}
            </div>
          </div>
        </Modal>

      )}







      <Snackbar
        title={snackbar.title}
        description={snackbar.description}
        type={snackbar.type}
        duration={3500}
        onClose={() => setSnackbar({ title: "", description: "", type: "info" })}
      />

      <ScrollToTopButton />


    </>
  )

}





